import VectorLayer from '@/models/vector-layer'
import vectorUtils from '@src/utils/vectorUtils'
import {LayerTypes} from '@models/layer'

export default class VectorCircleLayer extends VectorLayer {
  constructor (obj, needMap) {
    super(obj, needMap)
    if (needMap) {
      this._type = LayerTypes.VECTOR_CIRCLE
      let color = obj.color ? obj.color : vectorUtils.randomColor()
      this._paint = {
        'circle-color': color,
        'circle-opacity': 1,
        'circle-radius': 5,
        'circle-stroke-color': color,
        'circle-stroke-opacity': 1,
        'circle-stroke-width': 2
      }
    } else {
      Object.assign(this, obj)
    }
  }

  get colorPreview () {
    return this._paint['circle-color']
  }

  get mapboxOpacityKeys () {
    return ['circle-stroke-opacity', 'circle-opacity']
  }
}



// WEBPACK FOOTER //
// ./src/models/vector-circle-layer.js